import { gql } from "@apollo/client";

export const GET_TOP_SALE_TICKETS =gql`query getTopSalesTickets($month:String!,$year:String!) {
  getTopSalesTickets(topSalesInput: {month: $month, year: $year}) {
    leagueName
    totalCounts
  }
}`;

export const GET_REVENUE_SUPER_USER_DASHBOARD = gql `
query getRevenuesSuperUserDashboard ($startYear: Int!, $endYear: Int!, $startMonth: String!, $endMonth: String!) {
  getRevenuesSuperUserDashboard(revenuesSuperUserDashboardInput: {endMonth:$endMonth,endYear:$endYear,startMonth:$startMonth,startYear:$startYear}) {
    getRevenueForSuperUser {
      monthsName
      revenue
      totalTickets
    }
    getRevenueForSuperUserAggregate {
      avgListPrice
      overAllSales
      overAllTickets
      quickasystFee
    }
  }
}`;

export const GET_PENDING_TICKETS = gql `
query getPendingTicketsDashboard {
  getPendingTicketsDashboard {
    getPendingActiveTicketsByLeague {
      activeTickets
      leagueName
    }
    getPendingActiveTicketsCountAndPayout {
      potentialPayout
      totalCount
    }
  }
}
`;

export const GET_REVENUE_ADMIN = gql`
query RevenuesDashboard ($startYear: Int!, $endYear: Int!, $startMonth: String!, $endMonth: String!) {
  getRevenueForAdmin(args: {endMonth:$endMonth,endYear:$endYear,startMonth:$startMonth,startYear:$startYear}) {
    monthsName
    revenue
    totalTickets
  }
  getRevenueForAdminAggregate(args: {endMonth:$endMonth,endYear:$endYear,startMonth:$startMonth,startYear:$startYear}) {
    overAllTickets
    overAllSales
    quickasystFee
    avgListPrice
  }
}
`;